import { useMatch } from "react-router-dom";

const useIsTemplateMode = () => useMatch("/template/*") !== null;

export default useIsTemplateMode;
